import type { CapKeyDto } from "../../types/CapKeyDto";
import type { CapKeyEntity } from "../../types/CapKeyEntity";

export const CapKeyDtoToEntity = ({ ...rest }: Readonly<CapKeyDto>): CapKeyEntity => {
    return { ...rest };
};
